import React from 'react'
import { StyledTH } from '../../../styles/Components/Table'

export default function () {
  return <>
    <StyledTH>Name</StyledTH>
  </>
}
